import React, { useState, useEffect, useRef } from 'react';
import Label from '@/components/form/Label/Label';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const fetchUserLocation = async () => {
  try {
    const response = await fetch('http://ip-api.com/json/');
    if (!response.ok) throw new Error(`Error: ${response.status}`);
    const data = await response.json();
    return { lat: data.lat, lng: data.lon };
  } catch (error) {
    console.error('Error fetching location:', error);
    return null;
  }
};

const cdmxBounds = new window.google.maps.LatLngBounds(
  new window.google.maps.LatLng(19.183, -99.334),
  new window.google.maps.LatLng(19.6, -98.96),
);

const popularNeighborhoods = [
  {
    description: 'Coyoacán, CDMX, Mexico',
    name: 'Coyoacán',
    imageUrl: '/images/Coyoacán.png',
    coords: { lat: 19.3497, lng: -99.1627 },
  },
  {
    description: 'Del Valle (Centro), CDMX, Mexico',
    name: 'Del Valle (Centro)',
    imageUrl: '/images/DelValleCentro.png',
    coords: { lat: 19.3712, lng: -99.165 },
  },
  {
    description: 'Narvarte Centro, CDMX, Mexico',
    name: 'Narvarte Centro',
    imageUrl: '/images/Narvarte_Centro.png',
    coords: { lat: 19.378, lng: -99.1592 },
  },
  {
    description: 'Nápoles, CDMX, Mexico',
    name: 'Nápoles',
    imageUrl: '/images/Napoles.png',
    coords: { lat: 19.396, lng: -99.173 },
  },
  {
    description: 'Roma Norte, CDMX, Mexico',
    name: 'Roma Norte',
    imageUrl: '/images/Roma_Norte.png',
    coords: { lat: 19.4174, lng: -99.1685 },
  },
  {
    description: 'Polanco, CDMX, Mexico',
    name: 'Polanco',
    imageUrl: '/images/Polanco.png',
    coords: { lat: 19.4326, lng: -99.1956 },
  },
  {
    description: 'Condesa, CDMX, Mexico',
    name: 'Condesa',
    imageUrl: '/images/Condesa.png',
    coords: { lat: 19.4145, lng: -99.1737 },
  },
  {
    description: 'San Rafael, CDMX, Mexico',
    name: 'San Rafael',
    imageUrl: '/images/San_Rafael.png',
    coords: { lat: 19.4475, lng: -99.164 },
  },
  {
    description: 'Escandón, CDMX, Mexico',
    name: 'Escandón',
    imageUrl: '/images/Escandón.png',
    coords: { lat: 19.4021, lng: -99.1785 },
  },
  {
    description: 'Juárez, CDMX, Mexico',
    name: 'Juárez',
    imageUrl: '/images/Juarez.png',
    coords: { lat: 19.4271, lng: -99.1621 },
  },
];

const SearchSuggestions = ({
  currentLang,
  popularNeighborhoods,
  handleClickLocation,
}) => {
  return (
    <FlexContainer className="flex-column width100">
      <FlexContainer className="flex-column width100 margb30">
        <FlexContainer
          className="flex-wrap justify-between"
          style={{ rowGap: '20px' }}
        >
          {popularNeighborhoods.map((location, index) => (
            <FlexContainer
              key={index}
              className="position-relative border-rad8px overflow-hidden height-110px grayShadowBottom"
              style={{ width: '48%', backgroundColor: 'rgba(255,255,255,0.1)' }}
              onClick={() => handleClickLocation(location)}
            >
              <FlexContainer
                className="pos-abs top0 left0 right0 bottom0"
                style={{
                  backgroundImage: `url(${location?.imageUrl})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  zIndex: 1,
                }}
              />
              <FlexContainer
                className="pos-abs left0 right0 height100 align-items-center justify-center"
                style={{
                  backgroundColor: 'rgba(14,14,14,0.40)',
                  zIndex: 2,
                }}
              >
                <Label className="text-18 text-center fontWhite">
                  {location?.description}
                </Label>
              </FlexContainer>
            </FlexContainer>
          ))}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const TrendingLocations = props => {
  const { currentLang, popularNeighborhoods, handleClickLocation } = props;
  return (
    <>
      <FlexContainer className="align-items-center margb15 margt20">
        <i
          className="fas fa-arrow-trend-up text-14 margr16 "
          style={{
            color: 'rgba(255,255,255,0.9)',
          }}
        ></i>
        <Label className="text-18">
          {currentLang === 'EN'
            ? 'Trending Locations'
            : 'Ubicaciones Populares'}
        </Label>
      </FlexContainer>

      <FlexContainer className="flex-column margb10 margtb20 padlr32 gap-20">
        {popularNeighborhoods.map((item, index) => (
          <FlexContainer
            key={index}
            className="align-items-center"
            onClick={() => handleClickLocation(item)}
          >
            <Label className="text-14">{item.name}</Label>
          </FlexContainer>
        ))}
      </FlexContainer>
    </>
  );
};

const DowntownSection = props => {
  const { currentLang, selectedValue } = props;
  return (
    <>
      <FlexContainer className="margt10 width100 padl28">
        <FlexContainer className="width100">
          <Label
            className="width100 height-1px"
            style={{
              width: '97%',
              backgroundColor: 'rgba(255,255,255,0.2)',
            }}
          />
        </FlexContainer>
      </FlexContainer>

      <FlexContainer className="align-items-center margb15 margt20 margb10">
        <i
          className="fas fa-paper-plane text-14 margr16"
          style={{
            color: 'rgba(255,255,255,0.9)',
          }}
        ></i>
        <Label className="text-14">{selectedValue?.description}</Label>
      </FlexContainer>

      <FlexContainer className="margt10 width100 padl28">
        <FlexContainer className="width100">
          <Label
            className="width100 height-1px"
            style={{
              width: '97%',
              backgroundColor: 'rgba(255,255,255,0.2)',
            }}
          />
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

const RecentSearches = props => {
  const { currentLang, selectedValue } = props;
  return (
    <>
      <FlexContainer className="align-items-center margb15 margt20">
        <i
          className="fa-solid fa-clock-rotate-left text-14 margr16"
          style={{
            color: 'rgba(255,255,255,0.9)',
          }}
        ></i>
        <Label className="text-18">
          {currentLang === 'EN' ? 'Recent Searches' : 'Búsquedas Recientes'}
        </Label>
      </FlexContainer>

      <FlexContainer className="margb10 margtb10 padlr30">
        <Label className="text-14 line-height-1-5">Condesa, CDMX, Mexico</Label>
      </FlexContainer>

      <FlexContainer className="margt10 width100 padl30">
        <FlexContainer className="width100">
          <Label
            className="width100 height-1px"
            style={{
              width: '97%',
              backgroundColor: 'rgba(255,255,255,0.2)',
            }}
          />
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

const LocationGrid = props => {
  const { currentLang, locations, selectedValue } = props;
  const locationRegex = /cdmx/i;
  return (
    <>
      <FlexContainer className="align-items-center margb15">
        <i
          className="fas fa-map-marker-alt text-14 margr16"
          style={{
            color: 'rgba(255,255,255,0.9)',
          }}
        ></i>
        <Label className="text-20 margtb6">
          {currentLang === 'EN'
            ? 'Spaces in ' + selectedValue?.description
            : 'Espacios en ' + selectedValue?.description}
        </Label>
      </FlexContainer>

      <FlexContainer className="margb10 margt6 padlr28">
        <Label className="text-14">
          {currentLang === 'EN'
            ? 'Find the best coworking spaces to have productive days and take meetings on the fly'
            : 'Encuentra los mejores espacios de coworking para tener días productivos y tomar reuniones sobre la marcha'}
        </Label>
      </FlexContainer>
      {(locationRegex.test(selectedValue?.city) ||
        locationRegex.test(selectedValue?.description)) && (
        <FlexContainer className="justify-between width100 margt10 padl28 gap-4">
          {locations.map((location, index) => (
            <FlexContainer
              key={index}
              className="flex-column align-items-center width100"
            >
              <img
                src={location.image}
                alt={location.description}
                className="grayShadowBottom width100 height-80px border-rad8px objectCover"
                loading="lazy"
                style={{
                  backgroundColor: 'rgba(255,255,255,0.1)',
                }}
              />
              <Label className="text-14 margt8 text-center">
                <strong>{location.description}</strong>
              </Label>
            </FlexContainer>
          ))}
        </FlexContainer>
      )}
    </>
  );
};

const SearchBar = props => {
  const { currentLang, onBack, searchMode, setSearchMode, locationFromSearch } =
    props;
  const [inputValue, setInputValue] = useState('');
  const [userLocation, setUserLocation] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const autocompleteService = useRef(null);
  const currentSearchFormData = useSelector(state => state.searchFormData);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const initializeAutocomplete = () => {
      if (!autocompleteService.current && window.google) {
        autocompleteService.current =
          new window.google.maps.places.AutocompleteService();
      }
    };

    fetchUserLocation().then(location => setUserLocation(location));

    if (!window.google) {
      window.addEventListener('load', initializeAutocomplete);
      return () => window.removeEventListener('load', initializeAutocomplete);
    } else {
      initializeAutocomplete();
    }
  }, []);

  const handleInputChange = e => {
    setSearchMode(true);
    const searchValue = e.target.value;
    setInputValue(searchValue);

    if (searchValue.length > 3 && autocompleteService.current) {
      if (userLocation) {
        autocompleteService.current.getPlacePredictions(
          {
            input: searchValue,
            bounds: cdmxBounds,
            strictBounds: true,
          },
          (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              setSuggestions(predictions);
              console.log('Ver las predicciones: ', suggestions);
            }
          },
        );
      } else {
        autocompleteService.current.getPlacePredictions(
          { input: searchValue },
          (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              setSuggestions(predictions);
              console.log('Ver las predicciones: ', suggestions);
            }
          },
        );
      }
    } else if (searchValue.length === 0) {
      setSuggestions([]);
    }
  };

  const handleClickOnSuggestion = suggestion => {
    console.log(suggestion);
    if (suggestion?.place_id && window.google) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement('div'),
      );
      service.getDetails({ placeId: suggestion.place_id }, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          let coordinatesFromSuggestion = place.geometry.location.toJSON();
          dispatch(
            setSearchFormData({
              ...currentSearchFormData,
              locationFromSearch: suggestion,
              coordinates: coordinatesFromSuggestion,
            }),
          );
          setSearchMode(false);
          navigate('/');
        } else {
          console.error('Error fetching place details:', status);
        }
      });
    }
  };

  return (
    <>
      <FlexContainer className={'margt60 align-items-end'}>
        <i
          className="fa fa-chevron-left"
          onClick={onBack}
          style={{
            color: locationFromSearch ? 'white' : 'black',
          }}
        ></i>
        <Label
          className={`fontBlack text-12 margl10  ${
            locationFromSearch ? 'fontWhite' : 'fontBlack'
          }`}
          onClick={onBack}
        >
          {currentLang === 'EN' ? 'Back' : 'Atrás'}
        </Label>
      </FlexContainer>
      <FlexContainer className="margt20 align-items-center  width100">
        <FlexContainer
          className="align-items-center grayShadowBottom border-rad12px margr10 padtb8 padlr16 flex-1"
          style={{
            backgroundColor: 'rgba(123, 154, 201)',
            transition: 'all 0.2s ease',
            border: '2px solid rgba(108, 130, 171)',
            minWidth: 0,
          }}
        >
          <i
            className="fa fa-search margr10 noShrink "
            style={{
              color: 'rgba(255,255,255)',
            }}
          ></i>
          <input
            type="text"
            value={inputValue}
            placeholder={
              currentLang === 'EN'
                ? 'Type a neighborhood in Mexico City'
                : 'Busca alguna colonia o barrio en CDMX'
            }
            onChange={handleInputChange}
            className="placeholder-custom-W bgTransparent borderNone text-16 text-left width100 outlineNone fontWhite flex-1 textTransformNone"
            style={{
              minWidth: 0,
            }}
          />
        </FlexContainer>
      </FlexContainer>
      {searchMode && (
        <FlexContainer className={'flex-column'}>
          {suggestions?.map(suggestion => (
            <FlexContainer
              className={'margt10 align-items-center justify-between width100'}
              onClick={() => handleClickOnSuggestion(suggestion)}
            >
              <FlexContainer
                className={
                  locationFromSearch
                    ? 'align-items-center border-rad8px margr10 padtb8 padlr16 flex-1'
                    : 'bgGradientBlue align-items-center border-rad8px margr10 padtb8 padlr16 flex-1'
                }
                style={{
                  backgroundColor: 'rgba(255,255,255,0.10)',
                  transition: 'all 0.2s ease',
                  minWidth: 0,
                }}
              >
                {suggestion?.description}
              </FlexContainer>
            </FlexContainer>
          ))}
        </FlexContainer>
      )}
    </>
  );
};

const LocationsView = props => {
  const {
    languageData,
    coloniasArray,
    popularNeighborhoods,
    handleClickLocation,
    locations,
    goToWorkspaceMap,
  } = props;
  const currentSearchFormData = useSelector(state => state.searchFormData);
  const currentLang = languageData || 'EN';
  const [searchMode, setSearchMode] = useState(true);
  const locationFromSearch = currentSearchFormData?.locationFromSearch;
  const background = !locationFromSearch ? 'locationsBG' : 'bgGradientBlue';

  return (
    <FlexContainer
      className={
        background +
        ' flex-column padlr10 justify-start items-center height-1000px fontWhite'
      }
    >
      <SearchBar
        currentLang={currentLang}
        onBack={goToWorkspaceMap}
        setSearchMode={setSearchMode}
        searchMode={searchMode}
        locationFromSearch={locationFromSearch}
      />
      <FlexContainer className="width100 margt10">
        <FlexContainer className="width100">
          <Label
            className="width100 height-1px"
            style={{
              backgroundColor: 'rgba(255,255,255,0.2)',
            }}
          />
        </FlexContainer>
      </FlexContainer>
      {!locationFromSearch && (
        <FlexContainer className="flex-column margt10 padlr20">
          <SearchSuggestions
            currentLang={currentLang}
            handleClickLocation={handleClickLocation}
            popularNeighborhoods={popularNeighborhoods}
          />
        </FlexContainer>
      )}
      {locationFromSearch && (
        <FlexContainer className="flex-column margt10 padlr20">
          <LocationGrid
            currentLang={currentLang}
            locations={locations}
            popularNeighborhoods={popularNeighborhoods}
            selectedValue={locationFromSearch}
          />
          <DowntownSection
            currentLang={currentLang}
            selectedValue={locationFromSearch}
          />
          <RecentSearches
            currentLang={currentLang}
            selectedValue={locationFromSearch}
          />
          <TrendingLocations
            selectedValue={locationFromSearch}
            popularNeighborhoods={popularNeighborhoods}
            handleClickLocation={handleClickLocation}
            currentLang={currentLang}
            coloniasArray={coloniasArray}
          />
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default LocationsView;
